export const apiPaths = {
  classrooms: "/classrooms",
  exercises: "/exercises",
  import: "/import",
  levels: "/levels/:level/exercises",
  licenses: "/licenses",
  mockExams: "/mock-exams",
  payments: "/payments",
  practiceTests: "/practice-tests",
  schools: "/schools",
  schoolTeachers: "/teachers",
  signUp: "/login/sign-up",
  subdomains: "/subdomains",
  submissions: "/submissions",
  userClassrooms: "/users/:userId/classrooms",
  userCompletedExercises: "/users/:userId/completed-exercises/:level",
  users: "/users",
  distributors: "/distributors",
  orders: "/orders",
};
